import { formatInDisplayZone, parseApiDate } from '@shared/lib/format-date';

/** Единый формат даты и времени во всём ЛК (МСК), не зависит от языка интерфейса. */
export const formatDateTime = (iso: string, _locale?: string): string => {
  const date = parseApiDate(iso);
  if (!date) {
    return iso;
  }

  return formatInDisplayZone(date, 'dd.MM.yyyy HH:mm:ss');
};

export const isFutureIso = (iso: string | null | undefined, now = Date.now()): boolean => {
  if (!iso) {
    return false;
  }

  const time = new Date(iso).getTime();
  return !Number.isNaN(time) && time > now;
};

export const retryAfterMinutes = (seconds: number): number => Math.max(1, Math.ceil(seconds / 60));
